import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import { IconButton, Menu, MenuItem } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';

export const MobileNavigation: React.FC = ({ ...other }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const navigate = useNavigate();

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClick = (pathname: string | null = null) => {
    setAnchorEl(null);

    if (pathname) {
      navigate({
        pathname,
      });
    }
  };

  return (
    <Box {...other}>
      <IconButton aria-label="menu" aria-controls="simple-menu" aria-haspopup="true" onClick={handleOpenMenu}>
        <MenuIcon style={{ color: '#fff' }} />
      </IconButton>

      <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={() => handleClick()}>
        <MenuItem onClick={() => handleClick('/')}>Home</MenuItem>
        <MenuItem onClick={() => handleClick('/azienda')}>Azienda</MenuItem>
        <MenuItem onClick={() => handleClick('/negozio')}>Negozio</MenuItem>
        <MenuItem onClick={() => handleClick('/ordina')}>Ordina online</MenuItem>
        <MenuItem onClick={() => handleClick('/contatti')}>Contatti</MenuItem>
      </Menu>
    </Box>
  );
};
